<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

/**
 * Side-by-side layout: 2–4 columns, each holding its own ordered blocks
 * (one nesting level — a column can't hold another `columns`). Public
 * renderer; the editor draws its own drop zones around the same
 * <SiteColumnsFrame> shell. Children render through <SiteBlockRenderer>,
 * which resolves components at runtime, so there is no import cycle.
 */
const props = defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()

const cols = computed(() => props.data.cols ?? [])
</script>

<template>
  <SiteColumnsFrame
    :ratio="data.ratio"
    :gap="data.gap"
    :vertical-align="data.vertical_align"
    :stack-on-mobile="data.stack_on_mobile !== false"
  >
    <template #column="{ i }">
      <SiteBlockRenderer
        v-if="cols[i]"
        :blocks="cols[i]!.blocks"
        nested
      />
    </template>
  </SiteColumnsFrame>
</template>
